/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Developer_Copy_SecretInputs */



/**
* | output |
* | --- |
* | "Copy secret" |
*
* @param {Developer_Copy_SecretInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const developer_copy_secret = /** @type {((inputs?: Developer_Copy_SecretInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Developer_Copy_SecretInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Copier le secret")
	if (locale === "es") return /** @type {LocalizedString} */ ("Copiar secreto")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Copiar secret")
	if (locale === "it") return /** @type {LocalizedString} */ ("Copia secret")
	return /** @type {LocalizedString} */ ("Copy secret")
});